import { render, staticRenderFns } from "./csDuty.vue?vue&type=template&id=0160849a&scoped=true&"
import script from "./csDuty.vue?vue&type=script&lang=js&"
export * from "./csDuty.vue?vue&type=script&lang=js&"
import style0 from "./csDuty.vue?vue&type=style&index=0&id=0160849a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0160849a",
  null
  
)

export default component.exports